import { Oberbegriff } from 'src/app/data/ws/oberbegriff.model';
import { Rubrik } from 'src/app/data/ws/rubrik.model';
import {
  Component,
  OnInit /*ApplicationRef, Injector, ComponentFactoryResolver , ViewContainerRef, ComponentRef, ComponentFactory, EmbeddedViewRef, OnDestroy, Input  */,
} from '@angular/core';
//import { Guid } from 'guid-typescript';
import { UserDatenRubrikMenge } from 'src/app/data/user/user-daten-rubrik-menge.model';
import { MatTableDataSource } from '@angular/material/table';
import { ConstantsTableColsRubrik } from 'src/app/immutable/table-cols/constants-table-cols-rubrik';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import {
  InputErrorStateMatcher,
  GlobalConstantsRegex,
  ValueFormat,
} from 'globales-projekt-angular';
import { MainComponent } from 'src/app/components/pages/anwendung/main/main.component';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-oberbegriff-akkordeon',
  templateUrl: './oberbegriff-akkordeon.component.html',
  styleUrls: ['./oberbegriff-akkordeon.component.css'],
})
export class OberbegriffAkkordeonComponent implements OnInit {
  faInfoCircle = faInfoCircle;

  id: string;

  oberbegriff: Oberbegriff = null;
  werteLinks: number[] = [];
  werteRechts: number[] = [];
  formControlLinksList: FormControl[];
  formControlRechtsList: FormControl[];

  dataRubrikLinks: MatTableDataSource<Rubrik> = new MatTableDataSource();
  dataRubrikRechts: MatTableDataSource<Rubrik> = new MatTableDataSource();
  displayedColsRubrik: string[] = ConstantsTableColsRubrik.getColumns();

  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();
  expanded: boolean = false;
  parentMainComponent: MainComponent;
  valueFormat: ValueFormat = new ValueFormat();

  formControlNumberFormatWarning: string = GlobalConstantsRegex.GANZ_ZAHL_LAENG_6_ODER_KOMMA_2_TEXT;

  constructor() {}

  ngOnInit(): void {}

  clearAllInputFields() {
    this.expanded = false;
    let i: number = 0;
    this.werteLinks = [];
    for (let {} of this.dataRubrikLinks.data) {
      this.werteLinks.push(null);
      this.formControlLinksList[i].setValue(null);
      i++;
    }

    i = 0;
    this.werteRechts = [];
    for (let {} of this.dataRubrikRechts.data) {
      this.werteRechts.push(null);
      this.formControlRechtsList[i].setValue(null);
      i++;
    }
  }

  createErrorFormControl() {
    this.formControlLinksList = [];
    this.formControlRechtsList = [];

    for (let {} of this.dataRubrikLinks.data) {
      this.formControlLinksList.push(
        new FormControl(
          '',
          Validators.pattern(
            GlobalConstantsRegex.GANZ_ZAHL_LAENG_6_ODER_KOMMA_2
          )
        )
      );
    }

    for (let {} of this.dataRubrikRechts.data) {
      this.formControlRechtsList.push(
        new FormControl(
          '',
          Validators.pattern(
            GlobalConstantsRegex.GANZ_ZAHL_LAENG_6_ODER_KOMMA_2
          )
        )
      );
    }
  }

  getRubrikMenge(): UserDatenRubrikMenge[] {
    let i: number = -1;

    let userDatenRubrikMengeList: UserDatenRubrikMenge[] = [];

    for (let entry of this.werteLinks) {
      let val: number = entry;
      i++;

      if (val == null) continue;

      let userDatenRubrikMenge: UserDatenRubrikMenge =
        new UserDatenRubrikMenge();
      userDatenRubrikMenge.idRubrik = this.dataRubrikLinks.data[i].idRubrik;
      userDatenRubrikMenge.menge = val;

      userDatenRubrikMengeList.unshift(userDatenRubrikMenge);
    }

    i = -1;
    for (let entry of this.werteRechts) {
      i++;
      let val: number = entry;

      if (val == null) continue;

      let userDatenRubrikMenge: UserDatenRubrikMenge =
        new UserDatenRubrikMenge();
      userDatenRubrikMenge.idRubrik = this.dataRubrikRechts.data[i].idRubrik;
      userDatenRubrikMenge.menge = val;

      userDatenRubrikMengeList.unshift(userDatenRubrikMenge);
    }

    return userDatenRubrikMengeList;
  }

  setLastUserDatenEingabe(userDatenRubrikMenge: UserDatenRubrikMenge[]) {
    this.expanded = false;
    userDatenRubrikMenge = userDatenRubrikMenge;

    for (let entry of userDatenRubrikMenge) {
      let i = 0;
      for (let entry2 of this.dataRubrikLinks.data) {
        if (entry.idRubrik == entry2.idRubrik) {
          this.werteLinks[i] = entry.menge;
          this.formControlLinksList[i].setValue(this.valueFormat.getStringDecimal(entry.menge, 2));
          this.expanded = true;
          break;
        }
        i++;
      }

      i = 0;

      for (let entry2 of this.dataRubrikRechts.data) {
        if (entry.idRubrik == entry2.idRubrik) {
          this.werteRechts[i] = entry.menge;
          this.formControlRechtsList[i].setValue(this.valueFormat.getStringDecimal(entry.menge, 2));
          this.expanded = true;
          break;
        }

        i++;
      }
    }
  }

  setValueRechts(e: any, i: number) {
    let val: number = this.valueFormat.parseNumber(e.target.value);

    if (val == 0 || val == null) {
      this.werteRechts[i] = null;
    } else {
      this.werteRechts[i] = val;
    }

    this.parentMainComponent.checkZumErgebnis();
  }
  setValueLinks(e: any, i: number) {
    let val: number = this.valueFormat.parseNumber(e.target.value);

    if (val == 0 || val == null) {
      this.werteLinks[i] = null;
    } else {
      this.werteLinks[i] = val;
    }

    this.parentMainComponent.checkZumErgebnis();
  }

  isFelderGueltig(): boolean {
    //    let i: number = 0;

    for (let entry of this.formControlLinksList) {
      if (entry.valid == false) {
        /*    alert(
          GlobalFunctions.replacePlatzhalter(
            GlobalConstantsTexte.EINGABEFELDER_AKKORDEON_FALSCHER_WERT,
            this.id,
            this.dataRubrikLinks.data[i].socName
          )
        ); */
        return false;
      }
      //    i++;
    }

    //   i = 0;

    for (let entry of this.formControlRechtsList) {
      if (entry.valid == false) {
        /*   alert(
          GlobalFunctions.replacePlatzhalter(
            GlobalConstantsTexte.EINGABEFELDER_AKKORDEON_FALSCHER_WERT,
            this.id,
            this.dataRubrikRechts.data[i].socName
          )
        );*/
        return false;
      }

      //  i++;
    }

    return true;
  }
}
